import React from 'react';
import toast from 'react-hot-toast';
import { L } from '@app/shared/lib/i18n';
import { Button } from '../Buttons/Button';

type Args = {
    continueFn: () => void;
    continueButtonText: string;
    title: string;
};

const triggerDirtyFieldsToast = async ({ continueFn, continueButtonText, title }: Args) =>
    toast(
        (t) => (
            <div>
                <p>{L(title)}</p>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button
                        onClick={() => {
                            toast.dismiss(t.id);
                            continueFn();
                        }}
                    >
                        {continueButtonText}
                    </Button>
                    <Button variant="filledPrimary" onClick={() => toast.dismiss(t.id)}>
                        {L('no')}
                    </Button>
                </div>
            </div>
        ),
        { duration: Infinity }
    );

export default triggerDirtyFieldsToast;
